/* eslint-disable */
import _ from 'underscore';
import backbone from 'backbone';
var defaults = {
  schedule: undefined,
  task: undefined,
  asyncInterface: 'promise',
  timeout: 0,
  cancellationToken: undefined,
  overlapping: 'allow'
};
var Task = function (options) {
  this.options = _.defaults({}, options, defaults);
  if (!this.options.schedule) {
    throw new Error('asyncScheduler: schedule option must be provided');
  }
  if (!this.options.task) {
    throw new Error('asyncScheduler: task option must be provided');
  }
};
Task.prototype.start = function () {
  this.isRunning = true;
  this._scheduleNext();
  return this;
};
Task.prototype.stop = function () {
  this.isRunning = false;
  if (this.next) {
    clearTimeout(this.next);
  }
  return this;
};
Task.prototype._scheduleNext = function (current) {
  this.next = setTimeout(_.bind(this._iteration, this, current), this.options.schedule);
};
Task.prototype._iteration = function (previous) {
  if (previous && !previous.completed && this.options.overlapping === 'wait') {
    previous.isAwait = true;
    return;
  }
  var iteration = this._startTask();
  if (this.isRunning === true) {
    this._scheduleNext(iteration);
    if (this.options.timeout) {
      this._scheduleTimeout(iteration);
    }
  }
};
Task.prototype._startTask = function () {
  var iteration = {
    completed: false,
    isOverlapped: false
  };
  if (this.options.asyncInterface === 'callback') {
    var callback = _.bind(this._callback, this, iteration);
    iteration.token = this.options.task(callback);
  } else {
    iteration.token = this.options.task();
    iteration.token.then(_.bind(this._callback, this, iteration, null), _.bind(this._callback, this, iteration));
  }
  return iteration;
};
Task.prototype._callback = function (iteration, error, data) {
  if (iteration.completed) {
    return;
  }
  clearTimeout(iteration.timeout);
  iteration.completed = true;
  if (iteration.isAwait) {
    this._iteration(iteration);
  }
  this.trigger(error ? 'error' : 'success', {
    error: error,
    data: data,
    stopTask: _.bind(this.stop, this)
  });
};
Task.prototype._scheduleTimeout = function (iteration) {
  if (this.options.cancellationToken && !_.isFunction(iteration.token[this.options.cancellationToken])) {
    throw new Error('asyncScheduler: "cancel" function is not found in task returned value');
  }
  iteration.timeout = setTimeout(_.bind(this._processTimeout, this, iteration), this.options.timeout);
};
Task.prototype._processTimeout = function (iteration) {
  if (this.options.cancellationToken) {
    iteration.token[this.options.cancellationToken]();
  }
  iteration.completed = true;
  if (iteration.isAwait) {
    this._iteration(iteration);
  }
  this.trigger('timeout', {
    stopTask: _.bind(this.stop, this)
  });
};
_.extend(Task.prototype, backbone.Events);
var createTask = function (options) {
  return new Task(options);
};
export default {
  createTask: createTask
};

